import {
  MCDANIEL_SEARCH_FOLDER_NAME,
  SYNC_KEY,
  isForecastTrumpingSource
} from "constants/settings.constants";

import { isSyncFolder } from "components/sync/util";

import { DataSourceSetting } from "../../components/data-table/DataTableActions";

const FORECAST_SUFFIXES = [".fcst", ".EUR", ".Remaining"];

/**
 * Qualify a single property name with forecast source suffix when applicable.
 */
export function qualifyPropertyWithForecast(
  property: string,
  forecastFolder?: string,
  rescat?: string
): string {
  if (!forecastFolder || forecastFolder === MCDANIEL_SEARCH_FOLDER_NAME) {
    return property;
  }

  const isForecastTrumping = isForecastTrumpingSource(forecastFolder);
  const rescatSuffix = rescat ? `.${rescat}` : "";

  if (isSyncFolder(forecastFolder) && property.startsWith("Performance")) {
    return `${property}.${SYNC_KEY}.${forecastFolder}${rescatSuffix}`;
  }

  if (
    property.startsWith("Performance.") &&
    FORECAST_SUFFIXES.some((suffix) => property.endsWith(suffix))
  ) {
    const addFcst = property.endsWith(".fcst") ? "" : ".fcst";
    const forecastSource = isForecastTrumping ? "" : `.${forecastFolder}`;
    return `${property}${addFcst}${forecastSource}${rescatSuffix}`;
  }

  if (property.startsWith("Forecast.")) {
    const forecastSource = isForecastTrumping ? "" : `.${forecastFolder}`;
    return `${property}.fcst${forecastSource}${rescatSuffix}`;
  }

  return property;
}

const getPropertiesWithForecast = (
  properties: string[],
  dataSources: DataSourceSetting
) => {
  return properties.map((prop) =>
    qualifyPropertyWithForecast(prop, dataSources.forecastSource, dataSources.rescat)
  );
};

export default getPropertiesWithForecast;
